import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; 

import { getUserFullName, urlHome, urlLogin, shortname, languages, enUS,
    languagesList, setLanguage, getMenuLabels,
    dashboardLabel,
    academyLabel,
    achievementsLabel,
    activityLabel,
    setMenuOpened,
    menuOpen,
    courseView,
    setCourseView,
    LanguageShort,
    urlAcademy,
    urlScore,
    urlActivity,
    loginLabel,
    selectLanguageLabel,
    getOrganization,
    signOutLabel,
    Language,
    websiteLabel,
    getLabel, 
    getToken,
    getUuid,
    warningEmailsLabel,
    nl,
    urlFalseEmails,
    useMobileView
} from '../../utils/constants';

import { 
  faRightFromBracket, faRightToBracket, 
  faXmark, faHouse, faSchool, 
  faFire, faArrowUpRightFromSquare, faGlobe,
  faHeartPulse,faWarning
} from '@fortawesome/free-solid-svg-icons';

import Level from '../../parts/Level/Level';

import MenuItem from '../../parts/MenuItem/MenuItem';
import Icons from '../../parts/Icons/Icons';

import style from './style.module.css'

import ExpandIcon from './components/Expand/ExpandIcon';

import { sysLabels } from '../../data/translations';
import { changeLanguage } from '../../services/authApi';

interface HeaderProps {
  isAuthenticated: boolean;
  language: string;
  handleSignOut: () => void;
}

type MenuItemLabel = {
  EN: string;
  RU: string;
  NL: string;
};

type MenuItemLabels = {
  [key: string]: MenuItemLabel;
};

const Header: React.FC<HeaderProps> = ({isAuthenticated, handleSignOut, language}) => {

  const activeToken = getToken();
  const uuid = getUuid();

  const isMobile = useMobileView();

  const dateYear = process.env.REACT_APP_YEAR;
  const disclaimer = process.env.REACT_APP_DISCLAIMER;
  const version = process.env.REACT_APP_VERSION;

  const [userMenuOpened,setUserMenuOpened] = useState<boolean>(false);
  const [appMenuOpened,setAppMenuOpened] = useState<boolean>(isMobile? false : true);
  const [languageMenuOpened,setLanguageMenuOpened] = useState<boolean>(false);
  const [menuItemLabels, setMenuItemLabels] = useState<MenuItemLabels>({});
  const [isCourseViewMode,setIsCourseViewMode] = useState<boolean>(true);

  const [organizationName,setOrganizationName] = useState(getOrganization()['name'])
  const [organizationShortName,setOrganizationShortName] = useState(getOrganization()['shortname'])

  const activeLanguage = (() => {
    if (!language) return languages(enUS);
    try {
      return JSON.parse(language);
    } catch {
      return null;
    }
  })();

  const getLocalLabel = (key: keyof typeof menuItemLabels, lang: LanguageShort) => {
    return menuItemLabels?.[key]?.[lang] || '';
  };

  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate(urlHome);
  }

  const handleMenu = () => {
    if(userMenuOpened){
      setUserMenuOpened(false)
      return
    }
    setUserMenuOpened(true)
  }

  const handleAppMenu = () => {
    if(appMenuOpened){
      setAppMenuOpened(false)
      setMenuOpened('false')
      return
    }
    setAppMenuOpened(true)
    setMenuOpened('true')
  }

  const handleAppMenuMobile = () => {
    if(isMobile){
      handleAppMenu()
    }
  }

  const handleLanguageSelect = () => {
    setLanguageMenuOpened(true)
  }

  const handleLanguage = async (lang: string | any) => {
    const newLanguage = languages(lang)

    await changeLanguage({ 
      uuid: uuid, 
      token: activeToken, 
      language: newLanguage.short
    });

    setLanguage(JSON.stringify(newLanguage))
    setLanguageMenuOpened(false)
  }

  useEffect(() => {
    if(!isAuthenticated){
      setUserMenuOpened(false)
    }
  }, [isAuthenticated])

  useEffect(() => {
    if (Object.keys(menuItemLabels).length === 0) {
      const labels = getMenuLabels();
      try {
        const parsedLabels = JSON.parse(labels);
        setMenuItemLabels(parsedLabels);
      } catch (e) {
        console.error('Failed to parse menu labels', e);
      }
    }
  }, [menuItemLabels]);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === menuOpen) {
        let newMenuOpenStatus = event.newValue;
        if (!newMenuOpenStatus || typeof newMenuOpenStatus === 'string'){
            setAppMenuOpened(newMenuOpenStatus === 'false' ? false : true);
        }
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);


  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === courseView) {
        let newCourseViewStatus = event.newValue;
        if (!newCourseViewStatus || typeof newCourseViewStatus === 'string'){
            setIsCourseViewMode(newCourseViewStatus === 'false' ? false : true);
        }
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);


  useEffect(() => {
    if(!isMobile){
      setMenuOpened("true")
    }
    setCourseView("false")
  }, [])
  
  const renderAppMenu = () => (
      <div className={`${style.userMenuWrapper} ${appMenuOpened ? style.active : ''}`}>
        <div className={style.appMenu}>

          <div className={style.userMenuIcon}>
            <div className={style.userMenuIconLeft}>
                  <div className={style.labelImg} onClick={handleGoHome}></div>
            </div> 
          </div>

          <div className={style.sideMenu}>
              { isAuthenticated ?
                  <>
                    <MenuItem icon={faHouse} label={getLocalLabel(dashboardLabel, activeLanguage.short)} link={urlHome} click={handleAppMenuMobile} />
                    <MenuItem icon={faSchool} label={getLocalLabel(academyLabel, activeLanguage.short)} link={urlAcademy} click={handleAppMenuMobile} />
                    <MenuItem icon={faWarning} label={getLocalLabel(warningEmailsLabel, activeLanguage.short)} link={urlFalseEmails} click={handleAppMenuMobile} />
                    <MenuItem icon={faFire} label={getLocalLabel(achievementsLabel, activeLanguage.short)} link={urlScore} click={handleAppMenuMobile} />
                    <MenuItem icon={faHeartPulse} label={getLocalLabel(activityLabel, activeLanguage.short)} link={urlActivity} click={handleAppMenuMobile} />
                  </> : 
                  <>
                    <MenuItem icon={faRightToBracket} label={getLocalLabel(loginLabel, activeLanguage.short)} link={urlLogin} click={handleAppMenuMobile} />
                  </>
              }
          </div>
          <div className={style.disclaimer}>
              <MenuItem icon={faGlobe} label={activeLanguage.name} flag={activeLanguage.flag} link={'#'} click={handleLanguageSelect} />
              <MenuItem icon={faArrowUpRightFromSquare} label={getLabel(websiteLabel,activeLanguage)} link={'https://' + getLabel(websiteLabel,activeLanguage).toLowerCase()} type={'link'} click={handleSignOut} />
              <div className={style.disclaimer_text}>
                  &copy; {dateYear} {disclaimer} &nbsp;&nbsp;&bull;&nbsp;&nbsp; {version}
              </div>
          </div>

        </div>
    </div>
  )

  const renderLanguage = () => (
    <div className={style.modal}>
      <div className={style.wrap}>
        <div className={style.langBox}>
            <Icons icon={faGlobe} />
            <div className={style.langTitle}>{getLocalLabel(selectLanguageLabel, activeLanguage.short)}</div>
            {
              Object.entries(languagesList).map(([key, lang]) => (
                <div className={style.lang} key={key} onClick={() => handleLanguage(key)}>
                  {lang.flag} {lang.name}
                </div>
              ))
            }
        </div>
      </div>
    </div>
  )

  const renderActionLinks = () => (
    <>
      <div>
        <Link to={urlLogin}>Login</Link>
      </div>
    </>
  );

  const renderUserMenuIcon = () => (
    <div className={style.userIcon}>{shortname(getUserFullName())}</div>
  )

  const renderUserMenu = () => (
    <div className={`${style.userMenuWrapper} ${userMenuOpened ? style.active : ''}`}>
      <div className={style.userMenu}>

        <div className={style.userMenuIcon}>
          <div className={style.userMenuIconLeft}>
              <div className={style.userMilLeft}>
                  {renderUserMenuIcon()}
              </div><div className={style.userMilRight}>
                <div className={style.userName}>{getUserFullName()}</div> 
                <div className={style.userCompany}>{organizationName}</div>
                <div className={style.userLevel}>
                  <Level click={handleMenu} />
                </div>
              </div>
          </div><div className={style.userMenuIconRight}>
                <div onClick={handleMenu} className={style.userMirClose}>
                    <Icons icon={faXmark} />
                </div>
          </div>  
        </div>

        {/*<div className={`${style.sideMenu} ${style.light}`}>
            <MenuItem icon={faUser} label={'Your Profile'} link={'/user/profile'} click={handleMenu} mode={'light'} />
            <MenuItem icon={faLandmark} label={'Your Organization'} link={'/user/organization'} click={handleMenu} mode={'light'} />
            <MenuItem icon={faUsers} label={'Your Employees'} link={'/user/employees'} click={handleMenu} mode={'light'} />
        </div>*/}

        <div className={`${style.sideMenu} ${style.light} ${style.short}`}>
          <MenuItem icon={faRightFromBracket} label={sysLabels[signOutLabel][((activeLanguage as unknown) as Language).short || 'EN']} link={'/'} click={handleSignOut} mode={'light'} />
        </div>
      </div>
    </div>
  );

  

  return (
    <>
    {
      !isCourseViewMode? 
        <>
          <div className={style.wrapper}>
            <div className={style.labelContainer}></div>
            <div className={style.loginWrapper}>
              {
                !isAuthenticated ? renderActionLinks() : 
                  <>
                  <div className={style.headerUserMenu} onClick={handleMenu}>
                      <div className={style.userCompany}>
                          <div className={style.ucName}>
                            {organizationShortName}
                          </div>
                      </div><div className={style.userUser}>
                          {renderUserMenuIcon()}
                      </div>
                  </div>
                  </>
              }
            </div>
          </div>
          <div className={style.menuToggle} onClick={handleAppMenu}>
            <ExpandIcon expand={appMenuOpened} />
          </div>
        </> : ''
    }
    {isAuthenticated && appMenuOpened && renderAppMenu()}
    {isAuthenticated && userMenuOpened && renderUserMenu()}
    {languageMenuOpened && renderLanguage()}
    </>
  );
};

export default Header;